import MultiSourceFileInput from './components/MultiSourceFileInput.vue';

export default {
  install(Vue, options) {
    Vue.component('multi-source-file-input', MultiSourceFileInput)
  }
}
